import { FC, PropsWithChildren } from 'react';
import { createPortal } from 'react-dom';
import styled from 'styled-components';

export interface FocusOverlayProps extends PropsWithChildren {
  x: number;
  y: number;
  width: number;
  height: number;
}

export const FocusOverlay: FC<FocusOverlayProps> = (props) => {
  const { x, y, width, height } = props;

  return createPortal(
    <OverlayContainer>
      <Overlay left={0} top={0} width="100%" height={y} />
      <Overlay
        left={0}
        top={y + height}
        width="100%"
        height={window.innerHeight - y - height}
      />
      <Overlay left={0} top={y} width={x} height={height} />
      <Overlay
        left={x + width}
        top={y}
        width={window.innerWidth - x - width}
        height={height}
      />
    </OverlayContainer>,
    document.body,
  );
};

const OverlayContainer = styled.div`
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  pointer-events: none;
`;

interface OverlayProps {
  left: number;
  top: number;
  width: number | string;
  height: number | string;
  background?: string;
}

const Overlay = styled.div<OverlayProps>`
  position: absolute;
  left: ${({ left }) => left}px;
  top: ${({ top }) => top}px;
  width: ${({ width }) => (typeof width === 'number' ? `${width}px` : width)};
  height: ${({ height }) =>
    typeof height === 'number' ? `${height}px` : height};
  background: ${({ background }) => background ?? 'rgba(255, 255, 255, 0.4)'};
  pointer-events: all;
`;
